<template>
  <div id="app">
    <NavMenu :loginName="loginName" v-if="showNavMenu"></NavMenu>
    <router-view @login-name="handleLoginName"/>
  </div>
</template>

<script>

import NavMenu from "@/components/NavMenu.vue";

export default {
  name: 'app',
  components: {
    NavMenu
  },
  data() {
    return {
      loginName: '用户名'
    }
  },
  computed: {
    showNavMenu() {
      return this.$route.path !== '/' && this.$route.path !== '/supermam/login' && localStorage.getItem('username');
    }
  },
  methods: {
    handleLoginName(login) {
      this.loginName = login.loginName
    }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>
